import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Session } from 'src/app/models/session';
import { SessionService } from 'src/app/services/storage/session.service';
import { LoginFAQComponent } from './documents/faq.component';
import { BaseModulePaths } from 'src/app/constants/routes';
import { Router } from '@angular/router';

@Component({
  selector: 'mwp-footer',
  templateUrl: './footer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FooterComponent implements OnInit {
  public appVersion: string;
  public copyright: string;
  public isLoggedIn: boolean = false;
  public isFaqsItemActive: boolean;
  public isTermsOfUseItemActive: boolean;
  public isPrivacyPolicyItemActive: boolean;
  public isDataProcessingAddendumItemActive: boolean;
  public isVersionError: boolean;
  public BaseModulePaths = BaseModulePaths;

  public faqsItem = {
    label: "FAQ'S",
    click: LoginFAQComponent,
    jsonKey: 'faqs',
  };

  constructor(private sessionService: SessionService, private router: Router) {}

  ngOnInit(): void {
    const today = new Date();
    this.copyright = `Copyright © ${today.getFullYear()} MyWorkplace, Inc.`;
    this.sessionService.$Session.subscribe((session: Session) => {
      if (session.operatingMode) {
        this.appVersion = session.operatingMode.version;
      }
      this.isLoggedIn = session.isLoggedIn;
      this.isFaqsItemActive = session.isFaqActive;
      this.isVersionError = session.isVersionIncompatible;
    });
  }

  public openDialog(component: any): void {
    this.sessionService.session.isFaqActive =
      !this.sessionService.session.isFaqActive;
    this.sessionService.setSession();
    return null;
  }

  public navigateToURL(linkURL: string): void {
    this.router.navigateByUrl(linkURL);
  }
}
